<template>
  <div v-clickout class="area-select" @clickout="$emit('toggle', false)">
    <div
      class="drop-downA"
      :class="{ selecting: selecting }"
      @click="$emit('toggle', !selecting)"
    >
      <div class="drop-down-sel ellipsis-1">
        {{ curArea.title || placeholder }}
      </div>
    </div>
    <div v-show="selecting" class="area-select__board">
      <div class="search-bar">
        <i class="icon-search"></i>
        <input
          v-model="searchKey"
          type="number"
          placeholder="快速搜索游戏区服"
        />
      </div>
      <div v-show="!searchKey" class="tabs">
        <span :class="{ cur: cur === -1 }" @click="cur = -1">最近玩过</span>
        <template v-for="(item, i) in tabs">
          <i :key="'i-' + item" class="divider"></i>
          <span
            :key="'s-' + item"
            :class="{ cur: cur === i }"
            @click="cur = i"
            >{{ item }}</span
          >
        </template>
      </div>
      <div class="board-box">
        <div class="area-select__board-line">
          <span
            v-for="item in curArr"
            :key="item.server_id"
            class="item"
            @click="
              $emit('change', item)
              $emit('toggle', false)
            "
          >
            <span
              class="ellipsis-1"
              :class="{ cur: curArea.server_id === item.server_id }"
              >{{ item.title }}</span
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clickout } from '~/plugins/vue-clickout'
export default {
  directives: {
    clickout
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String
    },
    curArea: {
      type: Object,
      default: () => ({})
    },
    playedArea: {
      type: Array,
      default: () => []
    },
    selecting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cur: -1,
      searchKey: null
    }
  },
  computed: {
    tabs() {
      const len = this.list.length
      if (len > 100) {
        const size = Math.ceil(len / 5)
        return Array.from(Array(5), (e, i) => {
          return i * size + 1 + '-' + (i + 1) * size
        })
      } else {
        const num = Math.ceil(len / 20)
        return Array.from(Array(num), (e, i) => {
          return i * 20 + 1 + '-' + (i + 1) * 20
        })
      }
    },
    curArr() {
      if (this.searchKey) {
        return this.list.filter((e) => e.title.includes(this.searchKey))
      }
      if (this.cur < 0) {
        return this.playedArea
      } else {
        const [start, end] = (this.tabs[this.cur] || '').split('-')
        const reverseList = [...this.list].reverse()
        return reverseList.slice(start - 1, end)
      }
    }
  },
  watch: {
    list() {
      this.cur = -1
    }
  },
  methods: {
    outClick() {
      if (this.selecting) {
        this.$emit('toggle', false)
      }
    }
  }
}
</script>

<style lang="scss">
.area-select {
  position: relative;
  display: inline-block;
  text-align: left;
  * {
    box-sizing: border-box;
  }
  &__board {
    position: absolute;
    z-index: 1;
    top: 48px;
    left: 0;
    width: 512px;
    height: 332px;
    background-color: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(183, 188, 206, 0.75);
    border-radius: 4px;
    border: solid 1px #c4d2f2;
    padding: 19px 10px;
    font-size: 14px;
    .search-bar {
      width: 225px;
      height: 22px;
      line-height: 22px;
      margin-bottom: 20px;
      input {
        font-size: 14px;
        color: #afbdd9;
        margin-left: 17px;
        border: none;
        border-bottom: 1px solid #afbdd9;
      }
    }
    .tabs {
      color: #a4acbe;
      span {
        cursor: pointer;
      }
      .cur {
        color: #508aff;
        font-weight: bold;
      }
    }
    .board-box {
      margin-top: 26px;
      height: 200px;
      overflow: auto;
      overscroll-behavior: none;
      &::-webkit-scrollbar {
        width: 4px;
        height: 80px;
        background-color: #ffffff;
      }

      &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #ffffff;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #d0e0ff;
      }
      &::-webkit-scrollbar-thumb:hover {
        background-color: #508aff;
      }
    }
    &-line {
      height: 30px;
      line-height: 30px;
      margin-bottom: 10px;
    }
    .item {
      display: inline-block;
      height: 100%;
      color: #3e3e52;
      width: 110px;
      cursor: pointer;
      span {
        display: inline-block;
        padding: 0 10px;
        box-sizing: border-box;
        max-width: 100%;
        vertical-align: bottom;
        &:hover {
          background-color: #eef4ff;
        }
        &.cur {
          background-color: #eef4ff;
        }
      }
    }
    .letter {
      color: #508aff;
      margin-right: 9px;
    }
  }
}
</style>
